/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Field_Delivery_FromInputs */

const en_po_field_delivery_from = /** @type {(inputs: Po_Field_Delivery_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery from`)
};

/**
* | output |
* | --- |
* | "Delivery from" |
*
* @param {Po_Field_Delivery_FromInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_field_delivery_from = /** @type {((inputs?: Po_Field_Delivery_FromInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Field_Delivery_FromInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_field_delivery_from(inputs)
});